"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.OverlayController = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
var OverlayController = /*#__PURE__*/function () {
  function OverlayController() {
    var _this = this;
    _classCallCheck(this, OverlayController);
    this.provider = void 0;
    this.resetModalState = function () {
      _this.provider.reset();
    };
    this.show = function (id) {
      _this.provider.setStateForOverlay({
        id: id,
        isShowing: true
      });
    };
    this.hide = function (id) {
      _this.provider.removeOverlay(id);
    };
    this.setIsClosable = function (id, isClosable) {
      _this.provider.setStateForOverlay({
        id: id,
        isClosable: isClosable
      });
    };
    this.setOnClose = function (id, cb) {
      _this.provider.setStateForOverlay({
        id: id,
        onCloseCb: cb
      });
    };
    this.setInitialFocusId = function (id, initialFocusId) {
      _this.provider.setStateForOverlay({
        id: id,
        initialFocusId: initialFocusId
      });
    };
    this.setFocusEnabledRefs = function (id, focusEnabledRefs) {
      _this.provider.setStateForOverlay({
        id: id,
        focusEnabledRefs: focusEnabledRefs
      });
    };
    this.setAnimate = function (id, animate) {
      _this.provider.setStateForOverlay({
        id: id,
        animate: animate
      });
    };
    this.setSrName = function (id, srName) {
      _this.provider.setStateForOverlay({
        id: id,
        srName: srName
      });
    };
    this.setContent = function (id, Content) {
      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if ( /*#__PURE__*/_react["default"].isValidElement(Content)) {
        _this.provider.setStateForOverlay({
          id: id,
          content: Content
        });
        return;
      }
      _this.provider.setStateForOverlay({
        id: id,
        content: /*#__PURE__*/_react["default"].createElement(Content, props)
      });
    };
    this.setHeader = function (id, header) {
      _this.provider.setStateForOverlay({
        id: id,
        header: header
      });
    };
    this.setFooter = function (id, footer) {
      _this.provider.setStateForOverlay({
        id: id,
        footer: footer
      });
    };
    this.setType = function (id, type, renderOptions) {
      _this.provider.setStateForOverlay({
        id: id,
        type: type,
        renderOptions: renderOptions
      });
    };
    this.setConfig = function (id, config) {
      _this.provider.setStateForOverlay(_objectSpread({
        id: id
      }, config));
    };
  }
  _createClass(OverlayController, [{
    key: "setProvider",
    value: function setProvider(provider) {
      this.provider = provider;
    }
  }]);
  return OverlayController;
}();
exports.OverlayController = OverlayController;
var _default = new OverlayController();
exports["default"] = _default;